import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import {
  AccountContainer,
  AccountHeader,
  AccountHeaderLeft,
  AccountHeaderRight,
  AccountFirstRow,
  AccountFirstRowOptions,
  AccountSecondRow,
  AccountTable,
  AccountThirdRow,
  BellIcon,
  GearIcon,
  TransferIcon,
  BillIcon,
  CreditCardIcon,
  NewAccountIcon,
} from "../StyledComponents/AccountStyles";
import { PersonalLoansIcon } from "../StyledComponents/LandingStyles";

export default function Account({ userData }) {
  const navigate = useNavigate();

  useEffect(() => {
    const hasFalsyValue = Object.values(userData).some((value) => !value);
    if (hasFalsyValue) {
      console.log("User data is missing!");
      navigate("/");
    }
  }, [userData]);

  function generateRandomPrice() {
    const randomNumber = Math.floor(Math.random() * (50000 - 1000 + 1)) + 1000;
    const cents = Math.floor(Math.random() * 100);
    return `$ ${randomNumber.toLocaleString()}.${cents
      .toString()
      .padStart(2, "0")}`;
  }

  function generateRandomFourDigitNumber() {
    const randomNumber = Math.floor(Math.random() * 9000) + 1000;
    return `x${randomNumber}`;
  }

  return (
    <AccountContainer>
      <AccountHeader>
        <div>
          <AccountHeaderLeft>
            <span>
              <p>
                {userData.userId
                  ? userData.userId?.charAt(0).toUpperCase()
                  : ""}
              </p>
            </span>
            <span>
              <p>{userData?.userId}</p>
              <p>
                Member since{" "}
                {userData?.accountEstablishedDate
                  ? new Date(
                      userData.accountEstablishedDate * 1000
                    ).toLocaleDateString("en-US")
                  : ""}
              </p>
            </span>
          </AccountHeaderLeft>
          <AccountHeaderRight>
            <span>
              <p>Account Number</p>
              <p>{userData?.accountId}</p>
            </span>
            <div>
              <BellIcon />
              <GearIcon />
            </div>
          </AccountHeaderRight>
        </div>
      </AccountHeader>
      <div>
        <AccountFirstRow>
          <p>
            How can we help you,{" "}
            {`${userData?.familyName} ${userData?.givenName}`}?
          </p>
          <AccountFirstRowOptions>
            <div>
              <TransferIcon />
              <p>Make a transfer</p>
            </div>
            <div>
              <BillIcon />
              <p>Pay a bill</p>
            </div>
            <div>
              <CreditCardIcon />
              <p>Open a credit card</p>
            </div>
            <div>
              <PersonalLoansIcon />
              <p>Apply for a loan</p>
            </div>
            <div>
              <NewAccountIcon />
              <p>Add a new account</p>
            </div>
          </AccountFirstRowOptions>
          <div>
            <p>
              Our friends at Heraldic Insurance are offering discounted fraud
              insurance for Indicio Banking Demo users.
            </p>
            <button>Get started</button>
          </div>
        </AccountFirstRow>
        <AccountSecondRow>
          <h2>Account Summary</h2>
          <div>
            <div>
              <p>Checking</p>
            </div>
            <AccountTable>
              <thead>
                <tr>
                  <th>Account</th>
                  <th>Available Balance</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Checking {generateRandomFourDigitNumber()}</td>
                  <td>{generateRandomPrice()}</td>
                </tr>
              </tbody>
            </AccountTable>
          </div>
          <div>
            <div>
              <p>Savings</p>
            </div>
            <AccountTable>
              <thead>
                <tr>
                  <th>Account</th>
                  <th>Available Balance</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Savings {generateRandomFourDigitNumber()}</td>
                  <td>{generateRandomPrice()}</td>
                </tr>
                <tr>
                  <td>HSA {generateRandomFourDigitNumber()}</td>
                  <td>{generateRandomPrice()}</td>
                </tr>
              </tbody>
            </AccountTable>
          </div>
        </AccountSecondRow>
        <AccountThirdRow>
          <h2>Transaction History</h2>
          <div>
            <p>No recent transaction history</p>
          </div>
        </AccountThirdRow>
      </div>
    </AccountContainer>
  );
}
